import { Subject, debounceTime, switchMap, distinctUntilChanged } from 'rxjs';
import { useObservable } from './useObservable';
import { helpers } from '@vuelidate/validators';
export function useDebounceValidator(api, ms = 250) {
    const flow = new Subject();
    const result = useObservable(flow.pipe(distinctUntilChanged(), debounceTime(ms), switchMap((data) => api(data))), false);
    const validator = helpers.withAsync((input) => {
        flow.next(input);
        return result.value;
    }, result);
    return { validator };
}
//# sourceMappingURL=useDebounceValidator.js.map